import { Outlet, useLocation } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Footer from './Footer';
import DesktopHeader from './DesktopHeader';
import MobileHeader from './MobileHeader';
import { useEffect, useRef } from 'react';
import lineIcon from '../img/line.png';

const useStyles = makeStyles({
  Main: {
    paddingLeft: "24px", paddingRight: "24px"
  },
  LineIcon: {
    position: "fixed",
    right: "15px",
    bottom: "25px",
    textAlign: "center",
  },
});

const PageLayout = () => {
  const mainRef = useRef(null);
  const classes = useStyles();
  const theme = useTheme();
  const location = useLocation();
  const matches = useMediaQuery(theme.breakpoints.up('md'));
  useEffect(() => {
    if (location.state) {
      if (location.state.anchor && location.state.anchor == "default") {
        mainRef.current?.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" });
      }
    }
  }, [location]);

  return (
    <div>

      {
        matches ? <DesktopHeader /> : <MobileHeader />
      }
      <main className={classes.Main} ref={mainRef}>
        <Outlet />
      </main>

      <Footer />
      <div className={classes.LineIcon}>
        <a href="https://lin.ee/x4EtxPH" target="_blank" rel="noreferrer noopener" title='點此以加入官方帳號為好友' style={{textDecoration:"none"}}>
          <img src={lineIcon} alt="line" style={{ width: '34px', height: 'auto' }} />
          <div style={{ fontSize: '0.75rem', fontWeight: 'bold', color: '#2F3941', marginTop: '4px' }}>
            專人諮詢
          </div></a>

      </div>

    </div>
  );
}

export default PageLayout;